import { Types } from "./FormacionDesarrolloContext";

const ModalReducer = (state: any, action:any) => {
    const {payload, type} = action;

    switch(type){
        case Types.CREATE_COURSE:
            return{
                ...state,
                _id: payload._id,
                createModalCourse:true
            }
        case Types.DELETE_COURSE:
            return{
                ...state,
                _id: payload._id,
                deleteModalCourse:true
            }
        case Types.CLEAR_COURSE:
            return{
                ...state,
                _id:'',
                createModalCourse:payload.createModalCourse,
                deleteModalCourse: payload.deleteModalCourse,
                updateModalCourse: payload.updateModalCourse
            }
        case Types.CREATE_USER_COURSE:
            return{
               ...state,
                createModalUserCourse:true
            }
        case Types.CLOSE_USER_COURSE_MODAL:
            return{
               ...state,
                createModalUserCourse:false
            }
        case Types.UPDATE_COURSE:
            return{
                ...state,
                _id: payload._id,
                updateModalCourse: true
            }
        default:
            return state;
    }
}
export default ModalReducer